import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLang } from "@/contexts/LanguageContext";

const LegalPage = ({ pageKey }) => {
  const { t } = useLang();
  const doc = t.legal[pageKey];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pageKey]);

  if (!doc) return null;

  return (
    <div data-testid={`legal-${pageKey}`} className="grain">
      <Header />
      <main className="pt-32 md:pt-40 pb-24 border-t border-white/5">
        <div className="container-hk">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-block mb-10 text-[10px] font-semibold tracking-[0.3em] text-white/60 hover:text-[var(--hk-red)] transition-colors"
          >
            {t.legal.backHome}
          </Link>

          <div className="text-[10px] tracking-[0.35em] text-[var(--hk-red)] font-bold mb-4">
            {t.legal.lastUpdated}
          </div>
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl uppercase leading-[0.95] tracking-tight mb-8 max-w-3xl">
            {doc.title}
          </h1>
          <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-3xl mb-16">
            {doc.intro}
          </p>

          <div className="space-y-10 max-w-3xl">
            {doc.sections.map((s, i) => (
              <section key={i} className="border-t border-white/10 pt-6">
                <h2 className="font-display text-xl md:text-2xl uppercase tracking-tight mb-3">
                  {s.h}
                </h2>
                <p className="text-sm md:text-[15px] text-white/70 leading-relaxed">
                  {s.p}
                </p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
